export default __webpack_public_path__ + "static/media/Digital library.e99ae400.gif";